import {
  isCordovaApp,
  cordovaFetchSiteConfig,
  cordovaFetchSiteLanguages
} from "../utils/cordovaUtils";
import { get } from "./utils";
import { Site } from "./typedefs/Site";

const baseURL = process.env.REACT_APP_SITE_API || "https://api.global.bible/";

const DOMAINS = [
  "global.bible",
  "lvh.me",
  "global-bible-prod.us-east-1.elasticbeanstalk.com",
  "gbibl.com"
];

const isSupportedDomain = (domain: string) =>
  DOMAINS.some(supportedDomain => domain.endsWith(supportedDomain));

export const fetchSiteConfig = async (domain: string): Promise<Site> => {
  if (isCordovaApp) return (await cordovaFetchSiteConfig()) as Site;

  const domainIsSupported = isSupportedDomain(domain);
  const siteType = domainIsSupported ? "subdomain" : "domain";
  const siteValue = domainIsSupported ? domain.split(".")[0] : domain;

  return get<{ site: Site }>(
    `${baseURL}sites/findOne?${siteType}=${siteValue}`
  ).then(data => data.site);
};

export const fetchSiteById = (id: string) =>
  get<{ site: Site }>(`${baseURL}sites/findOne?subdomain=${id}`).then(
    data => data.site
  );

export const fetchSiteLanguages = async ({
  primaryLanguage,
  secondaryLanguage
}: {
  primaryLanguage?: string;
  secondaryLanguage?: string | null;
}) => {
  if (!primaryLanguage) return;

  let requestString = `${baseURL}languages/${primaryLanguage}`;
  if (secondaryLanguage)
    requestString = `${requestString}?fallbackLanguageId=${secondaryLanguage}`;

  const fetchDictionary = isCordovaApp
    ? cordovaFetchSiteLanguages()
    : get(requestString);
  const { languageDictionaries } = (await fetchDictionary) as any;

  return languageDictionaries;
};
